import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "./firebase";
import MillionaireHostView from "./MillionaireHostView";
import MillionairePlayerView from "./MillionairePlayerView";

const MillionaireLiveGamePage = () => {
  const { gameId } = useParams();
  const [searchParams] = useSearchParams();
  const [gameData, setGameData] = useState(null);
  const [loading, setLoading] = useState(true);

  const isHost = searchParams.get("host") === "true";
  const playerId = searchParams.get("playerId") || null;

  useEffect(() => {
    if (!gameId) return;

    const unsub = onSnapshot(doc(db, "liveGames", gameId), (docSnap) => {
      if (docSnap.exists()) {
        setGameData(docSnap.data());
      }
      setLoading(false);
    });

    return () => unsub();
  }, [gameId]);

  if (loading) {
    return (
      <div className="welcome-screen">
        <h2 style={{ color: "#ffeaa7" }}>Loading game...</h2>
      </div>
    );
  }

  if (!gameData) {
    return (
      <div className="welcome-screen">
        <h2 style={{ color: "#ffeaa7" }}>Game not found.</h2>
      </div>
    );
  }

  if (gameData.currentQuestionIndex === 0) {
    return (
      <div className="welcome-screen">
        <h2 style={{ color: "#ffeaa7", fontSize: "2rem" }}>
          Waiting for host to start the game...
        </h2>
      </div>
    );
  }

  return isHost ? (
    <MillionaireHostView gameId={gameId} gameData={gameData} />
  ) : (
    <MillionairePlayerView gameId={gameId} playerId={playerId} gameData={gameData} />
  );
};

export default MillionaireLiveGamePage;
